import type { LeadList } from '@/types';

/** The protected list the Chrome extension saves people into. */
export const EXTENSION_LEADS_LIST_NAME = 'Extension Leads';

/** Where an import into Extension Leads is offered and refused. */
export const EXTENSION_LEADS_IMPORTS_NOTE =
  'Extension Leads only collects people you save with the Chrome extension. To import people, open another list.';

type ListLike = Pick<LeadList, 'name' | 'is_protected'>;

/**
 * Matched like the API (extension_leads_locked): other protected lists still
 * take imports, and a list someone names "Extension Leads" isn't protected.
 */
export const isExtensionLeads = (list?: ListLike | null): boolean =>
  Boolean(list?.is_protected) && list?.name === EXTENSION_LEADS_LIST_NAME;

/** Lists people can be imported into: every list but Extension Leads. */
export const importableLists = <T extends ListLike>(lists: readonly T[]): T[] =>
  lists.filter((list) => !isExtensionLeads(list));
